
const selector = '[data-highlight]';
const orchestratorContainerSelector = '.orchestrator-tree';
const crawlerContainerSelector = '.crawler-tree';

let orchestratorContainer: HTMLElement;
let crawlerContainer: HTMLElement;
let _currentHighlights: HTMLElement[] = [];

export function InitHighligthters(): void {

  _initContainers();

  document.querySelectorAll<HTMLElement>(selector).forEach(el => {
    el.addEventListener('mouseenter', scrollToAndHighlight);
    el.addEventListener('mouseleave', removeHighlight);
  });
}

export function DisposeHighligthters(): void {
  // remove event listeners from elements
  document.querySelectorAll<HTMLElement>(selector).forEach(el => {
    el.removeEventListener('mouseenter', scrollToAndHighlight);
    el.removeEventListener('mouseleave', removeHighlight);
  });

  // clear any current highlights
  if (_currentHighlights && _currentHighlights.length) {
    _currentHighlights.forEach(h => {
      h.classList.remove('highlight');
    });
  }
  _currentHighlights = [];

}

function _initContainers(): void {
  orchestratorContainer = document.querySelector<HTMLElement>(orchestratorContainerSelector) ?? document.body;
  crawlerContainer = document.querySelector<HTMLElement>(crawlerContainerSelector) ?? document.body;
  
}

function _getContainer(target: EventTarget | null): HTMLElement {
  if (!target || !(target instanceof HTMLElement)) {
    return orchestratorContainer ?? document.body;
  }
  // send the other than the closest container match
  if (target.closest(orchestratorContainerSelector)) return crawlerContainer;
  if (target.closest(crawlerContainerSelector)) return orchestratorContainer;
  // fallback
  return orchestratorContainer ?? crawlerContainer ?? document.body;
}

const scrollToAndHighlight = (event: Event) => {


  let container = _getContainer(event.currentTarget);

  let itemId = (event.currentTarget as HTMLElement).dataset.highlight;
  if (!itemId) return;

  const matches = Array.from(container.querySelectorAll<HTMLElement>(`[data-highlight="${itemId}"]`));
  if (!matches.length) return;

  // scroll to the first match
  const first = matches[0];
  scrollToElement(first);

  // clear previous highlights
  if (_currentHighlights && _currentHighlights.length) {
    _currentHighlights.forEach(h => {
      h.classList.remove('highlight');
    });
  }

  // highlight all matches and mark the first as active
  matches.forEach(m => m.classList.add('highlight'));
  _currentHighlights = matches;
}

const removeHighlight = (event: Event) => {
  if (_currentHighlights && _currentHighlights.length) {
    _currentHighlights.forEach(h => {
      h.classList.remove('highlight');
    });
  }
  _currentHighlights = [];
}


// Scroll into nearest scrollable ancestor if present, otherwise viewport
const scrollToElement = (el: HTMLElement) => {
  // start from parent to avoid treating the element itself as scroll container
  let ancestor: HTMLElement | null = el.parentElement;
  while (ancestor) {
    const style = window.getComputedStyle(ancestor);
    const overflowY = style.overflowY;
    if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
      // compute offset relative to ancestor using bounding rects
      const elRect = el.getBoundingClientRect();
      const ancRect = ancestor.getBoundingClientRect();
      const offset = ancestor.scrollTop + (elRect.top - ancRect.top) - (ancestor.clientHeight / 2) + (el.clientHeight / 2);
      // prefer smooth native scroll if available
      try {
        if (typeof (ancestor as any).scrollTo === 'function') {
          (ancestor as any).scrollTo({ top: offset, behavior: 'smooth' });
        } else {
          ancestor.scrollTop = offset;
        }
      } catch {
        ancestor.scrollTop = offset;
      }
      return;
    }
    ancestor = ancestor.parentElement;
  }
  // no scrollable ancestor found -> scroll viewport
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
